import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { ACCESS_TOKEN_KEY } from '../../constants/app.constants';
import { FeatureFlagsService } from '../feature-flag/feature-flag.service';
import { environment } from 'src/environments/environment';
import { AuthManagerService } from '../auth-manager/auth-manager.service';

@Injectable({ providedIn: 'root' })
export class DashboardInitGuard implements CanActivate {
  private isBrowser: boolean;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private featureFlags: FeatureFlagsService,
    private authManager: AuthManagerService,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): Observable<boolean> | boolean {
    if (this.isBrowser) {
      // If arrived from email
      if (next.queryParams['arrivedFromEmail']) {
        localStorage.setItem('arrived_from_email', 'true');
      }

      // Try to extract access_token from cookies
      const cookie = document.cookie.split('; ').find((row) => row.startsWith('access_token='));
      if (cookie) {
        const token = cookie.split('=')[1];
        localStorage.setItem(ACCESS_TOKEN_KEY, token);
      }

      if (
        !this.featureFlags.isEnabled('isHomeScreenAvailable') &&
        !this.authManager.isAuthenticated &&
        environment.isB2CLoginEnabled
      ) {
        window.location.href = environment.loginRedirectUrl;
      }
    }

    return true;
  }
}
